module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "submit"
  }, [_c('input', {
    staticClass: "form-submit btn btn-primary",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.to.label || 'Submit'
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04939093"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/elements/SubmitButton.vue
// module id = 1079
// module chunks = 0